<template>
  <div>
    <common-table :table-columns="tableColumns"
                  :url="url" :operate="operate"
                  :form-fields="formFields"
                  :permission="permission"
                  :buttons="buttons"
                  :searchs="searchs"
                  ref="table"></common-table>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable.vue";
import request from "@/utils/axios";
import message from "@/utils/message";

export default {
  name: 'MobileDevices',
  components: {CommonTable},
  data() {
    return {
      searchs: [/*{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }*/
        {
          name: 'name',
          placeholder: '设备名',
          type: 'input'
        }, {
          name: 'deviceId',
          placeholder: '设备ID',
          type: 'input'
        }, {
          name: 'state',
          placeholder: '设备状态',
          type: 'select',
          selectValue: [{
            key: 1,
            value: '在线',
          }, {
            key: 0,
            value: '离线',
          }]
        }, {
          name: 'status',
          placeholder: '状态',
          type: 'select',
          selectValue: [{
            key: 1,
            value: '启用',
          }, {
            key: 0,
            value: '禁用',
          }]
        }],
      permission: {
        // add: 'mobileDevices:add',
        update: 'mobileDevices:update',
        delete: 'mobileDevices:delete',
        deleteBatch: 'mobileDevices:deleteBatch'
      },
      url: {
        get: '/mobileDevices/listByCondition',
        // add: '/mobileDevices/add',
        update: '/mobileDevices/update',
        delete: '/mobileDevices/delete',
        delete_batch: '/mobileDevices/deleteBatch',
        status: '/mobileDevices/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'name',  // 字段名
        label: '设备名',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'deviceId',  // 字段名
        label: '设备ID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'ip',  // 字段名
        label: 'ip地址',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'airHandle',  // 字段名
        label: 'airHandle',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'mac',  // 字段名
        label: 'mac',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'userName',  // 字段名
        label: 'userName',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'version',  // 字段名
        label: 'version',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'model',  // 字段名
        label: 'model',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'srvName',  // 字段名
        label: 'srvName',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'width',  // 字段名
        label: 'width',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'height',  // 字段名
        label: 'height',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'deviceName',  // 字段名
        label: '手机型号',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'location',  // 字段名
        label: 'location',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'state',  // 字段名
        label: '在线状态',  // 字段显示名称
        sort: false,  // 是否排序
        show: {
          type: 'select',
        },
        selectData: [{
          id: 1,
          name: '在线'
        }, {
          id: 0,
          name: '离线'
        }],
      }, {
        field: 'rotate',  // 字段名
        label: 'rotate',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'vid',  // 字段名
        label: 'vid',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'pid',  // 字段名
        label: 'pid',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'gid',  // 字段名
        label: 'gid',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'status',  // 字段名
        label: '状态',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
        status: true,
      }, {
        field: 'waitTime',  // 字段名
        label: '加载等待时间',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'number',  // 字段名
        label: '获取视频数量',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      } ,{
        field: 'extendTheWaitingTime',  // 字段名
        label: '延长等待',  // 字段显示名称
        sort: false,  // 是否排序
        show: {
          type: 'select',
        },
        selectData: [{
          id: 1,
          name: '延长等待'
        }, {
          id: 0,
          name: '不延长'
        }],
      },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'waitTime',  // 字段名
            label: '加载等待时间',  // 字段显示名称
            type: 'input',
            placeholder: '请输入加载等待时间',
            rules: [
              {required: true, message: '加载等待时间不能为空', trigger: 'blur'}
            ],
            add: false,
            update: true,
          }, {
            field: 'number',  // 字段名
            label: '获取视频数量',  // 字段显示名称
            type: 'input',
            placeholder: '请输入获取视频数量',
            rules: [
              {required: true, message: '获取视频数量不能为空', trigger: 'blur'}
            ],
            add: false,
            update: true,
          }, {
            field: 'extendTheWaitingTime',  // 字段名
            label: '延长等待',  // 字段显示名称
            type: 'select',
            selectData: [{
              id: 1,
              name: "延长等待"
            }, {
              id: 0,
              name: '不延长等待'
            }],
            placeholder: '请选择延长等待',
            add: false,
            update: true,
          }, {
            field: 'userName',  // 字段名
            label: 'userName',  // 字段显示名称
            type: 'input',
            placeholder: '请输入userName',
            rules: [
              {required: true, message: 'userName不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'version',  // 字段名
            label: 'version',  // 字段显示名称
            type: 'input',
            placeholder: '请输入version',
            rules: [
              {required: true, message: 'version不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'model',  // 字段名
            label: 'model',  // 字段显示名称
            type: 'input',
            placeholder: '请输入model',
            rules: [
              {required: true, message: 'model不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'deviceId',  // 字段名
            label: 'deviceId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入deviceId',
            rules: [
              {required: true, message: 'deviceId不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'srvName',  // 字段名
            label: 'srvName',  // 字段显示名称
            type: 'input',
            placeholder: '请输入srvName',
            rules: [
              {required: true, message: 'srvName不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'width',  // 字段名
            label: 'width',  // 字段显示名称
            type: 'input',
            placeholder: '请输入width',
            rules: [
              {required: true, message: 'width不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'height',  // 字段名
            label: 'height',  // 字段显示名称
            type: 'input',
            placeholder: '请输入height',
            rules: [
              {required: true, message: 'height不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'deviceName',  // 字段名
            label: 'deviceName',  // 字段显示名称
            type: 'input',
            placeholder: '请输入deviceName',
            rules: [
              {required: true, message: 'deviceName不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'location',  // 字段名
            label: 'location',  // 字段显示名称
            type: 'input',
            placeholder: '请输入location',
            rules: [
              {required: true, message: 'location不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'state',  // 字段名
            label: 'state',  // 字段显示名称
            type: 'input',
            placeholder: '请输入state',
            rules: [
              {required: true, message: 'state不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'rotate',  // 字段名
            label: 'rotate',  // 字段显示名称
            type: 'input',
            placeholder: '请输入rotate',
            rules: [
              {required: true, message: 'rotate不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'vid',  // 字段名
            label: 'vid',  // 字段显示名称
            type: 'input',
            placeholder: '请输入vid',
            rules: [
              {required: true, message: 'vid不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'pid',  // 字段名
            label: 'pid',  // 字段显示名称
            type: 'input',
            placeholder: '请输入pid',
            rules: [
              {required: true, message: 'pid不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'gid',  // 字段名
            label: 'gid',  // 字段显示名称
            type: 'input',
            placeholder: '请输入gid',
            rules: [
              {required: true, message: 'gid不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'name',  // 字段名
            label: 'name',  // 字段显示名称
            type: 'input',
            placeholder: '请输入name',
            rules: [
              {required: true, message: 'name不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          },
        ]
      },
      operate: [],
      buttons: [{
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '一键运行',
        permission: 'mobileDevices:update',
        click: () => {
          request.post({
            url: '/mobileDevices/updateAllStatus',
            success: (res) => {
              if (res.code === 0) {
                message.success("一键运行成功");
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          });
        }
      }]
    }
  }
}
</script>

<style scoped>

</style>
